//import moment from 'moment'; // Example for onSort prop
import React,{ Component, Fragment } from 'react'; // Import React
import { render } from 'react-dom'; // Import render method
import ReactDatatable from '@ashvin27/react-datatable';
import "./clientliststyle.css";
import ReactSpinner from 'react-bootstrap-spinner'


import logo from './35.gif';

import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';

/*import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup,
    Row, Col,
} from 'reactstrap';


import Datatable from 'react-bs-datatable'; // Import this package
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
} from 'reactstrap'; */



class ClientList extends React.Component{

   constructor(props) {
        super(props);
        this.columns = [
            {
                key: "client_name",
                text: "Client Name",
                className: "name",
                align: "left",
                sortable: true,
            },
            {
                key: "project_name",
                text: "Project Name",
                className: "address",
                align: "left",
                sortable: true
            },
           {
                key: "set_name",
                text: "Product Set",
                className: "postcode",
                sortable: true
            },
            {
                key: "productsstr",
                text: "Product List",
                className: "rating",
                align: "left",
                sortable: true
            },
           /*  {
                key: "type_of_food",
                text: "Type of Food",
                className: "type_of_food",
                sortable: true,
                align: "left"
            },*/
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 200,
                align: "left",
                sortable: false,
                cell: record => { 
                    return (
                        <Fragment>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => this.editRecord(record)}
                                style={{marginRight: '5px'}}>
                                <i className="fa fa-copy"></i>
                            </button>
                            <button 
                                className="btn btn-danger btn-sm" 
                                onClick={() => this.downloadclient(record)}>
                                <i className="fa fa-download"></i>
                            </button>
                        </Fragment>
                    );
                }
            }
        ];
        this.config = {
            page_size: 10,
            length_menu: [ 10, 20, 50 ],
            button: {
                excel: true,
              /*  print: true,
                extra: true, */
            }
        }
        
        this.state = {
            records: [],
            isOpen: false,
            fields: {tagname:'',cname:'',prjname:''},
            errors: {cname:""},
            currec:{},
             info:'',
            
        }
        this.cloneclient=this.cloneclient.bind(this);
        this.downloadclient=this.downloadclient.bind(this);
        this.extraButtons =[
            {
                className:"btn btn-primary buttons-pdf",
                title:"Export TEst",
                children:[
                    <span>
                    <i className="glyphicon glyphicon-print fa fa-print" aria-hidden="true" key="pdfbut"></i>
                    </span>
                ],
                onClick:(event)=>{
                    console.log(event);
                },
            },
           /* {
                className:"btn btn-primary buttons-pdf",
                title:"Export TEst",
                children:[
                    <span>
                    <i className="glyphicon glyphicon-print fa fa-print" aria-hidden="true" key="printbut"></i>
                    </span>
                ],
                onClick:(event)=>{
                    console.log(event);
                },
                onDoubleClick:(event)=>{
                    console.log("doubleClick")
                }
            },*/
        ]
    }

toggle5() {
    this.setState({
      isOpen: !this.state.isOpen
    });
    //console.log(this.state.fields.cname);
    //console.log(this.state.fields.prjname);
  }
   openModal = () => {
        this.state.fields.cname="";
        this.state.fields.prjname="";
        this.state.fields.tagname="";
        
    this.setState({ isOpen: true });

   }

  closeModal = () => {

  this.setState({ isOpen: false }); 
  //console.log(this.state.fields.cname);
    //console.log(this.state.fields.prjname);
    //console.log(this.state.fields.tagname);
    //console.log(this.state.currec);

     };

     componentWillMount() {
        this.getClientData();
      }

       getClientData = (pro) => {
              
               this.api=window.$apibase+"/api/clientlist";
              let cards={};
               
                fetch(this.api)
                  .then(response => response.json())
                  .then(res => {
                    //console.log(res);
                    let values = [...this.state.records];
               
                          this.setState({
                            records: res.map((item, itemIndex) => {
                            const list=item
                            return list;  
                            })
                          });
             

                    
                  });
        }

    editRecord(record) {
        //console.log("Edit Record", record);
        this.setState({currec:record});
        if(this.state.currec.id)
        {
            this.openModal();
        }
         
        

       

        

              
    }

    
    cloneclient(record)
    {
        const formData = new FormData(); 
        formData.append("client", 
        this.state.fields.cname, 
       ); 
    
    formData.append( 
        "prject", 
        this.state.fields.prjname, 
       ); 
    formData.append( 
        "prodset", 
        this.state.fields.tagname, 
     ); 
     formData.append( 
        "sourcecid", 
        this.state.currec.id 
     ); 

        this.clientapi=window.$apibase+"/api/cloneclient";
                 this.setState({info:"Processing..."});
                fetch(this.clientapi,
                {
                   method: 'POST',
                   body: formData, 
                  }).then(response =>response.blob())
                  .then((blob) => {
                                      let fname=(this.state.fields.cname!=''?this.state.fields.cname+".pdf":"Client Product.pdf");
                                      const url = window.URL.createObjectURL(new Blob([blob]));
                                        const link = document.createElement('a');
                                        link.href = url;
                                        link.setAttribute('download', "clientproduct.pdf");
                                        // 3. Append to html page
                                        document.body.appendChild(link);
                                        // 4. Force download
                                        link.click();
                                        // 5. Clean up and remove the link
                                        link.parentNode.removeChild(link);

                                      this.setState({selected:[],info:"Downloaded"});

                                  });
            this.closeModal();
    }

    downloadclient(record) 
    {
        //console.log("Delete Record", record);
          this.setState({currec:record});
          if(this.state.currec.id)
          {
              const formData = new FormData(); 
              formData.append("sourcecid",this.state.currec.id); 
              this.clientapi=window.$apibase+"/api/downloadclient";
    
                    this.setState({info:"Processing..."});
                    fetch(this.clientapi,
                    {
                       method: 'POST',
                       body: formData, 
                    }).then(response =>response.blob())
                    .then((blob) => {
    
                                          let fname=(this.state.currec.client_name!=''?this.state.currec.client_name+".pdf":"Client Product.pdf");
                                          const url = window.URL.createObjectURL(new Blob([blob]));
                                          const link = document.createElement('a');
                                          link.href = url;
                                          link.setAttribute('download', fname);
                                            // 3. Append to html page
                                            document.body.appendChild(link);
                                            // 4. Force download
                                            link.click();
                                            // 5. Clean up and remove the link
                                            link.parentNode.removeChild(link);
    
                                          this.setState({selected:[],info:"Downloaded"});
    
                                      });
          }
    }

    handleChange(field, e)
    {
  
        let name = e.target.name;
        let value = e.target.value;
        let errors = this.state.errors;
  
        switch (name)
        {
          case "cname":
            errors.cname=value.length < 5 ? 'Client Name must be at least 5 characters long!': '';
          break;
          default:
          break;
  
        }
  
        this.setState(prevState => {
                  prevState.fields[name] =  value;
                  return {
                          fields: prevState.fields
                          };
        });
  
        this.setState({errors, [name]: value});
    }

    render() {
      const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={this.openModal}>&times;</button>;
        return (
            <>
              <div className="col-md-12">
                <div className="form-row">
                    <div><h3>Status:{this.state.info}</h3></div>
                    { this.state.info==="Processing..."?
                      <div><ReactSpinner type="border" color="primary" size="5" /></div>:<span></span>}
                        <div className="col-sm-12">
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                extraButtons={this.extraButtons}
                            />
                        </div>
                            <div>
                                                    {/* <Button color="primary" onClick={this.openModal}>Modals with external button</Button>*/}
                                <Modal isOpen={this.state.isOpen} toggle={this.toggle5} className={this.props.className} external={externalCloseBtn}>
                                  <ModalHeader>Modal title</ModalHeader>
                                  <ModalBody>
                                            <div className="form-group col-sm-12">
                                                   <label htmlFor="cname">Client Name<span style={{color: "red"}}>(*)</span></label>
                                                   

                                                    <input  className="form-control" name="cname" id="cname_id"
                                                     type="text" value={this.state.fields.cname}
                                                        onChange={this.handleChange.bind(this, "cname")}
                                                    />
                                                    <span style={{color: "red"}}>{this.state.errors.cname}</span>
                                                </div>
                                                <div className="form-group col-sm-12">
                                                   <label htmlFor="prjname">Project Name</label>
                                                    <input  className="form-control" name="prjname" id="prname_id"
                                                     type="text"  value={this.state.fields.prjname}
                                                        onChange={this.handleChange.bind(this, "prjname")} 
                                                    />
                                                </div>
                                                <div className="form-group col-sm-12">
                                                   <label htmlFor="tagname">ProductSet Name</label>
                                                    <input ref="tagname" className="form-control" name="tagname" id="tagname_id"
                                                     type="text"  value={this.state.fields.tagname}
                                                        onChange={this.handleChange.bind(this, "tagname")} 
                                                    />
                                                </div>
                                  </ModalBody>
                                  <ModalFooter>
                                    <Button color="primary" onClick={this.cloneclient}>Save Client</Button>{' '}
                                    <Button color="secondary" onClick={this.closeModal}>Cancel</Button>
                                  </ModalFooter>
                                </Modal>
                            </div>
            
                </div>
              </div>
          </>
        );
    }
}

export default ClientList;